module.exports = __webpack_public_path__ + "img/1x.f26416c.jpg";